module.exports = __webpack_public_path__ + "img/sala_comercial.52e2084b.png";